import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { LocationSetTriggersResponse } from "./types";

export const getLocationSetTriggers = reactQueryFetcherAdapter(
  cacheKey,
  async (
    signal,
    { query, limit = 250 }: { query: string; limit?: number }
  ): Promise<LocationSetTriggersResponse> => {
    const data = {
      query,
      limit,
    };
    return await fetch("/engagement/location_set_triggers", "GET", data, { signal });
  }
);
